export enum ProgressNoteBy {
  nurse = "nurse",
  provider = "provider",
}
